/*
 * -----------------------------------------------------------------------------------------
 * index.ts
 *
 * Copyright: (c) 2004-2020 Potthoff + Partner Unternehmensberatungs-Gesellschaft mbH
 *            All rights reserved.
 * -----------------------------------------------------------------------------------------
 * Erstellt : 13.10.2020
 * Autor    : Markus Plutka
 *
 * Geändert : 28.11.2022
 *      von : Jonas Wessel
 * -----------------------------------------------------------------------------------------
 *
 * Changelog:
 *
 */

import { Customer } from "models/customers";
import { combineReducers } from "redux";

import { applicationReducer, ApplicationState } from "./application";

export type State = {
  application: ApplicationState,
};

export default combineReducers({
  application: applicationReducer
});
